/**
 * Shared, client-safe constants for the newsletter signup.
 *
 * Kept out of the server action module because "use server" files may only
 * export async functions.
 */
export const NEWSLETTER_RECAPTCHA_ACTION = "newsletter_signup";

export type NewsletterState =
  | { status: "idle" }
  | { status: "success" }
  | { status: "error"; message: string };
